/* itg-collection.js
   Collection page: mobile sidebar, grid/list toggle, price-range checkboxes.
   Liquid renders all HTML — this file only binds events. */
(function () {
  var mobileSidebarOpen = false;
  var currentGridCols = "3";

  /* ── DOM helpers ─────────────────────────────────────────────────── */
  var qs = function (sel, ctx) {
    return (ctx || document).querySelector(sel);
  };
  var qsa = function (sel, ctx) {
    return (ctx || document).querySelectorAll(sel);
  };

  var getSidebar = function () {
    return (
      document.getElementById("main-collection-filters") ||
      document.getElementById("main-search-filters")
    );
  };

  /* ── Sidebar open / close ────────────────────────────────────────── */
  var openSidebar = function () {
    var sidebar = getSidebar();
    if (!sidebar) return;
    var overlay = qs(".itg-sidebar-overlay");
    sidebar.classList.add("is-open");
    if (overlay) overlay.classList.add("is-active");
    document.body.style.overflow = "hidden";
    mobileSidebarOpen = true;
  };

  var closeSidebar = function () {
    var sidebar = getSidebar();
    if (!sidebar) return;
    var overlay = qs(".itg-sidebar-overlay");
    sidebar.classList.remove("is-open");
    if (overlay) overlay.classList.remove("is-active");
    document.body.style.overflow = "";
    mobileSidebarOpen = false;
  };

  /* ── Bind sidebar toggle buttons (document-level delegation) ────── */
  var bindSidebarEvents = function () {
    /* Filter button and close button use delegation so they survive AJAX
       rebuilds and web-component re-renders without needing rebinding. */
    if (!document._itgSidebarBound) {
      document._itgSidebarBound = true;

      document.addEventListener("click", function (e) {
        if (e.target.closest(".itg-mobile-filter-btn")) {
          e.stopPropagation();
          openSidebar();
          return;
        }
        if (e.target.closest(".itg-sidebar-close")) {
          closeSidebar();
          return;
        }
      });
    }

    var overlay = qs(".itg-sidebar-overlay");
    if (overlay && !overlay.dataset.itgBound) {
      overlay.dataset.itgBound = "1";
      overlay.addEventListener("click", closeSidebar);
    }
  };

  /* ── Grid / list toggle (document-level delegation) ─────────────── */
  var bindGridToggle = function () {
    if (document._itgGridToggleBound) return;
    document._itgGridToggleBound = true;

    document.addEventListener("click", function (e) {
      var btn = e.target.closest(".skylabs-grid-btn");
      if (!btn) return;
      var toggle = btn.closest(".skylabs-grid-toggle");
      if (!toggle) return;

      qsa(".skylabs-grid-btn", toggle).forEach(function (b) {
        b.classList.remove("is-active");
      });
      btn.classList.add("is-active");
      currentGridCols = btn.dataset.cols;

      var grid = document.getElementById("product-grid");
      if (!grid) return;
      grid.classList.toggle("skylabs-list-view", btn.dataset.cols === "list");
    });
  };

  /* ── Re-apply grid view state after AJAX filter / sort update ────── */
  var reapplyGridView = function () {
    var grid = document.getElementById("product-grid");
    if (!grid) return;
    grid.classList.toggle("skylabs-list-view", currentGridCols === "list");

    /* Sync active state on the toggle buttons to match currentGridCols */
    var toggle = qs(".skylabs-grid-toggle");
    if (!toggle) return;
    qsa(".skylabs-grid-btn", toggle).forEach(function (b) {
      b.classList.toggle("is-active", b.dataset.cols === currentGridCols);
    });
  };

  /* ── Price range checkbox helpers ────────────────────────────────── */
  var setPriceInput = function (input, val) {
    if (!input) return;
    var param = input.dataset.param || input.getAttribute("name");
    if (val && val !== "0") {
      input.setAttribute("name", param);
      input.value = val;
    } else {
      input.removeAttribute("name");
      input.value = "";
    }
  };

  var clearPriceInputs = function (gte, lte) {
    if (gte) {
      gte.removeAttribute("name");
      gte.value = "";
    }
    if (lte) {
      lte.removeAttribute("name");
      lte.value = "";
    }
  };

  /* ── Price range checkboxes ──────────────────────────────────────── */
  var initPriceRangeCheckboxes = function () {
    qsa(".itg-price-range-cb").forEach(function (cb) {
      if (cb.dataset.itgBound) return;
      cb.dataset.itgBound = "1";

      var form = cb.closest("form");
      if (cb.checked && form) {
        var gte = form.querySelector(".itg-price-gte");
        var lte = form.querySelector(".itg-price-lte");
        if (gte && !gte.getAttribute("name"))
          setPriceInput(gte, cb.dataset.min);
        if (lte && !lte.getAttribute("name"))
          setPriceInput(lte, cb.dataset.max);
      }

      cb.addEventListener("change", function () {
        var f = cb.closest("form");
        if (!f) return;
        qsa(".itg-price-range-cb", f).forEach(function (other) {
          if (other !== cb) other.checked = false;
        });
        var gteInput = f.querySelector(".itg-price-gte");
        var lteInput = f.querySelector(".itg-price-lte");
        if (cb.checked) {
          setPriceInput(gteInput, cb.dataset.min);
          setPriceInput(lteInput, cb.dataset.max);
        } else {
          clearPriceInputs(gteInput, lteInput);
        }
        f.dispatchEvent(new Event("input", { bubbles: true }));
      });
    });
  };

  /* ── MutationObserver: react to AJAX filter / grid updates ──────── */
  var observeForAjaxUpdates = function () {
    var gridContainer = document.getElementById("ProductGridContainer");
    var filtersContainer = getSidebar();

    if (gridContainer) {
      new MutationObserver(reapplyGridView).observe(gridContainer, {
        childList: true,
      });
    }

    if (filtersContainer) {
      new MutationObserver(function () {
        initPriceRangeCheckboxes();
        bindSidebarEvents();
        if (mobileSidebarOpen) closeSidebar();
      }).observe(filtersContainer, { childList: true, subtree: true });
    }
  };

  /* ── Init ────────────────────────────────────────────────────────── */
  var init = function () {
    bindSidebarEvents();
    bindGridToggle();
    initPriceRangeCheckboxes();
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      init();
      observeForAjaxUpdates();
    });
  } else {
    init();
    observeForAjaxUpdates();
  }

  document.addEventListener("shopify:section:load", init);
})();
